import React from "react";
import styles from './FormikFileInput.module.scss';
import FormikCustomInput from '../formikCustomInput';
import FileInput from "./components/fileInput";
export interface IFormikCheckBoxesInputProps {
  name: string;
  form?: any;
  field?: any;
  fileInputComponent?: any;
}


const FormikFileInput = (props: IFormikCheckBoxesInputProps) => (
  <FormikCustomInput
    className={styles.fileInput}
    {...props}
    inputComponent={inputProps => <props.fileInputComponent
      {...inputProps}
    />}
  />
);

FormikFileInput.defaultProps = {
  name: "",
  label: "",
  okMode: false,
  labelInMiddleMode: false,
  fileInputComponent: FileInput,
};

export default FormikFileInput;
